import React, { useState } from "react";
import homealLogo from "../../images/homealLogo.png";
import { Modal, Button, Spinner } from "react-bootstrap";
import GetAPI from "../APICalls/GetQuery";
import PostAPI from "../APICalls/PostAPI";
import DeleteAPI from "../APICalls/DeleteAPI";

const DeleteAccount = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [accountExists, setAccountExists] = useState(null);
  const [loading, setLoading] = useState(false);
  const [responseOtp, setResponseOtp] = useState("");
  const [enteredOtp, setEnteredOtp] = useState("");
  const [userID, setUserID] = useState(null);
  const [otpSent, setOtpSent] = useState(false);

  let fetchOtp, userAPI;
  let environment = process.env.REACT_APP_NODE_ENV;
  if (environment === "PRODUCTION") {
    fetchOtp = process.env.REACT_APP_PROD_FETCHOTP;
    userAPI = process.env.REACT_APP_PROD_USERAPI;
  } else {
    fetchOtp = process.env.REACT_APP_DEV_FETCHOTP;
    userAPI = process.env.REACT_APP_DEV_USERAPI;
  }

  const handleSendOTP = () => {
    if (!/^\d{10}$/.test(mobileNumber)) {
      alert(
        "Please enter a valid 10-digit mobile number without spaces or special characters."
      );
      return;
    }

    const dataToPost = JSON.stringify({
      userMobile: "+91".concat(mobileNumber.toString()),
      otpType: "SMS",
    });

    PostAPI(fetchOtp, dataToPost)
      .then((res) => {
        setResponseOtp(res.data.body);
        setOtpSent(true);
      })
      .catch((e) => {});
  };

  const checkAccount = async () => {
    if (environment === "PRODUCTION") {
      if (parseInt(enteredOtp) !== parseInt(responseOtp)) {
        alert("wrong otp!!!");
        return;
      }
    } else {
      if (parseInt(enteredOtp) !== 1234) {
        alert("wrong otp!!!");
        return;
      }
    }

    const QUERY_PARAMS = {
      userMobile: "91".concat(mobileNumber),
    };

    setLoading(true);
    GetAPI(userAPI, QUERY_PARAMS)
      .then((res) => {
        setLoading(false);
        if (res.data.statusCode === 200) {
          if (Object.keys(res.data.body).length > 0) {
            setAccountExists(true);
            setUserID(res.data.body.userID)
          } else {
            alert("No account found with this number!!!");
            setOtpSent(false);
            setEnteredOtp("");
            setMobileNumber("")
          }
        } else {
          alert("Unable to get user details");
        }
      })
      .catch((e) => {
        setLoading(false);
        console.error(e);
        alert("Unable to get user details");
      });
  };

  const deleteAccount = async () => {
    setLoading(true);
   
       const QUERY_PARAMS = {
        userID: userID
      }
   
       DeleteAPI(userAPI, QUERY_PARAMS)
         .then((res) => {
           alert("account deleted successfully!!!");
           window.location.reload();
         })
         .catch((err) => {
           alert("Failed to delete account, please try again");
           console.log(err);
         });
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <img src={homealLogo} alt="Homeal Logo" style={styles.logo} />
      </div>
      <h6 style={styles.title}>Delete your account using the app</h6>

      <div style={styles.content}>
        <ol style={styles.list}>
          <li>Open the Homeal app.</li>
          <li>
            Tap the Profile Icon on the top right corner of the home screen.
          </li>
          <li>
            Click on <b>Settings</b> → <b>Delete</b>.
          </li>
          <li>Confirm the delete step to remove your account permanently.</li>
        </ol>
      </div>

      <div style={styles.content}>
        <h2 style={styles.title}>Delete Your Homeal Account here</h2>
        <h6 style={styles.subtitle}>Enter your mobile number</h6>

        <input
          style={styles.input}
          type="text"
          placeholder="Enter your 10-digit mobile number"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          maxLength={10}
        />

        {userID == null ?
        <Button variant="primary" onClick={handleSendOTP} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Send Otp"}
        </Button> : null}

        {otpSent ? (
          <>
            <p>Enter OTP to Verify</p>
            <div className="input-group input-group-sm mb-3">
              <input
                type="text"
                pattern="[0-9]*"
                maxLength={4}
                value={enteredOtp}
                onChange={(e) => {
                  setEnteredOtp((v) =>
                    e.target.validity.valid ? e.target.value : v
                  );
                }}
                className="form-control"
                aria-label="Small"
                aria-describedby="inputGroup-sizing-sm"
              />
            </div>
            {enteredOtp.length === 4 ? (
              <Button
                variant="primary"
                onClick={checkAccount}
                disabled={loading || userID !== null}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  "Verify Account"
                )}
              </Button>
            ) : null}
          </>
        ) : null}
      </div>

      {accountExists && (
          <Button variant="danger" onClick={() => setShowConfirmModal(true)}>
            Delete My Account
          </Button>
        )}

<h6 style={styles.subtitle}>Developer Name: Milan Monappa</h6>


      <Modal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete your account permanently?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button variant="danger" onClick={deleteAccount} disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : "Yes, Delete"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    color: "#333",
    lineHeight: 1.6,
    margin: "0 auto",
    maxWidth: "600px",
    padding: "1rem",
    textAlign: "center",
  },
  header: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "2rem",
  },
  logo: {
    height: "50px",
  },
  content: {
    textAlign: "left",
  },
  title: {
    fontSize: "1.8rem",
    color: "#2c3e50",
    marginBottom: "0.5rem",
  },
  subtitle: {
    fontSize: "1rem",
    color: "#7f8c8d",
    marginBottom: "1rem",
  },
  list: {
    paddingLeft: "20px",
    marginBottom: "1rem",
  },
  input: {
    width: "100%",
    padding: "0.5rem",
    fontSize: "1rem",
    border: "1px solid #ccc",
    borderRadius: "5px",
    marginBottom: "1rem",
  },
  errorText: {
    color: "red",
    marginTop: "0.5rem",
  },
};

export default DeleteAccount;
